import NewCommonServiceHero from "../../../common/NewCommonServices/NewCommonServiceHero";
import NewCommonServiceForm from "../../../common/NewCommonServices/NewCommonServiceForm";
import NewCommonMoreItService from "../../../common/NewCommonServices/NewCommonMoreItService";
import {
  SoftwareAndSaasDevelopmentIcon,
  WebsiteAndAppDevelopmentIcon,
  cloudAndDevops,
  cyberSecurity,
  mobileAndAppDevelopment,
} from "../../../../assets/icons/serviceIcon/index";
import { useEffect } from "react";

const items = [
  {
    name: "24/7 IT Support",
    text: "Issues don’t wait for office hours, and neither do we. Our team is always on standby to troubleshoot problems, minimize downtime, and keep everything running without a hitch.",
  },
  {
    name: "Proactive Maintenance",
    text: "Why wait for something to break? We monitor and maintain your systems, catching potential issues early so your business runs without unexpected disruptions or costly repairs.",
  },
  {
    name: "System Upgrades & Optimization",
    text: "Slow systems kill productivity. We handle updates, security patches, and performance tuning, making sure your technology stays fast, secure and ready for whatever’s next.",
  },
];

const otherService = [
  {
    icon: mobileAndAppDevelopment,
    name: "Mobile App Development",
    des: "We build apps that feel smooth, look great, and keep your users hooked.",
    path: "/mobile-app-development",
  },
  {
    icon: cloudAndDevops,
    name: "Cloud & DevOps Solutions",
    des: "No tech headaches - just fast, secure, and hassle-free cloud solutions.",
    path: "/cloud-devops-development",
  },
  {
    icon: SoftwareAndSaasDevelopmentIcon,
    name: "Software & SaaS Development",
    des: "Smart, scalable, and built for the long run - software that grows with you.",
    path: "/software-saas-development",
  },
  {
    icon: cyberSecurity,
    name: "Cybersecurity & Data Protection",
    des: "Your data stays yours! We lock it down so hackers don’t stand a chance.",
    path: "/cybersecurity-data-protection",
  },
  {
    icon: WebsiteAndAppDevelopmentIcon,
    name: "Website & App Development",
    des: "We build websites that tell stories, connect hearts and build brands.",
    path: "/web-app-development",
  },
];

const ItSupportAndMaintenance = () => {
  useEffect(() => {
    // Set Page Title
    document.title = "IT Support & Maintenance Services | TechQilla";

    // --- Description ---
    let metaDescription = document.querySelector<HTMLMetaElement>(
      "meta[name='description']",
    );
    if (!metaDescription) {
      metaDescription = document.createElement("meta");
      metaDescription.name = "description";
      document.head.appendChild(metaDescription);
    }
    metaDescription.setAttribute(
      "content",
      "Reliable IT support and maintenance services to ensure system stability, security, and performance for growing businesses.",
    );

    // --- Keywords ---
    let metaKeywords = document.querySelector<HTMLMetaElement>(
      "meta[name='keywords']",
    );
    if (!metaKeywords) {
      metaKeywords = document.createElement("meta");
      metaKeywords.name = "keywords";
      document.head.appendChild(metaKeywords);
    }
    metaKeywords.setAttribute(
      "content",
      "IT Support & Maintenance Services",
    );
    // --- Canonical ---
    let linkTag = document.querySelector<HTMLLinkElement>(
      "link[rel='canonical']",
    );
    if (!linkTag) {
      linkTag = document.createElement("link");
      linkTag.rel = "canonical";
      document.head.appendChild(linkTag);
    }
    linkTag.setAttribute(
      "href",
      "https://www.techqilla.com/it-support-maintenance",
    );
  }, []);
  return (
    <div>
      <NewCommonServiceHero
        heading="It Support &"
        colorHeading="Maintenance"
        description="Tech troubles shouldn’t slow you down. We keep your systems running smoothly with reliable support, regular maintenance and quick fixes, so you can focus on growing your business."
      />
      <NewCommonServiceForm title="It Support & Maintenance" items={items} />
      <NewCommonMoreItService items={otherService} />
    </div>
  );
};

export default ItSupportAndMaintenance;
